"use client";

import React, { useEffect, useState } from "react";
import styles from "./CardContainer.module.scss";
import ColorsCard from "../ColorCards";
import { colorCardType } from "../../Enum";
import { COLORS } from "../../helpers/constants";

interface CardContainerProps {
  data: colorCardType[];
  label?: string;
  showButton?: boolean;
  displayData?: boolean;
  layout?: string;
}

let isMobileScreen = true;
if (typeof window !== "undefined") {
  isMobileScreen = window.innerWidth < 600;
}
const CardContainer = ({
  data,
  label,
  showButton = isMobileScreen,
  displayData = !isMobileScreen,
                         layout = "flex"
}: CardContainerProps) => {
  const [showData, setShowData] = useState(displayData);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);
  return (
    <div className={styles.cardContainer}>
      {label && <h3 className={styles.label}>{label}</h3>}
      <div className={`${styles.cardLayout} ${layout == "grid" ? styles.cardGridLayout : ""}`}>
        {data?.slice(0, showData ? data?.length : 2)?.map((element, index) => {
          return (
            <ColorsCard {...element} bgColor={COLORS[index % COLORS.length]} />
          );
        })}
      </div>
      {isClient &&
        (showButton ? (
          <span
            className={styles.showButton}
            onClick={() => setShowData(!showData)}
          >
            {showData ? "See Less" : "See More"}
          </span>
        ) : (
          ""
        ))}
    </div>
  );
};

export default CardContainer;
